export default {
  extraDelayBannerLabel: {
    id: 'sav_conversion_extra_delay_banner_label',
    defaultMessage:
      "We're experiencing a surge in requests, please expect some delay.",
  },
}
